import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "absolute right-0 top-0 flex h-4.5 w-4.5 items-center justify-center rounded-full text-sm text-current lg:right-3 lg:top-3" }

import {computed, inject, onMounted, ref} from 'vue';
import LzIcon from '@/components/base/LzIcon.vue';
import { getCookie } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartButton',
  setup(__props) {

const site = inject('siteName') as string;
const link = computed(() => (process.env.VUE_APP_FRONTEND_URL || '') + `/shop/${site}/cart/`);
const quantity = ref(0);

onMounted(async () => {
    const cart = await getCart();
    if (cart) {
        quantity.value = cart.totalQuantity;
    }
});

async function getCart() {
    let headers: Record<string, string> = {
        'Content-Type': 'application/json',
    };
    const token = getCookie('authToken');
    headers = {
        ...headers,
        'Authorization': `Bearer ${token}`
    };
    const requestOptions = {
        method: 'POST',
        headers,
        body: JSON.stringify({
            query: `{
              activeOrder {
                totalQuantity
              }
            }`
        })
    };
    let response: Response = new Response();
    try {
        response = await fetch(`${process.env.VUE_APP_SHOP_URL}/shop-api`, requestOptions);
        const { data, errors } = await response.json();
        if (errors && !data) {
            // e.g. API access related errors, like auth issues.
            throw new Error(errors[0].message);
        }
        return data.activeOrder;
    } catch (error) {
        console.error(
            `Could not fetch from ${process.env.VUE_APP_SHOP_URL}/shop-api. Reason: ${error}`
        );
    }
}

return (_ctx: any,_cache: any) => {
  return (link.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: link.value,
        class: "group relative mr-6 flex h-10 w-10 items-center justify-center rounded-full text-md font-bold uppercase tracking-widest lg:h-18 lg:w-18"
      }, [
        _createVNode(LzIcon, {
          name: "cart",
          class: "h-5 w-5 shrink-0 fill-current lg:h-8 lg:w-8"
        }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(quantity.value), 1)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})